export default __webpack_public_path__ + "static/Content-2-6d9a09c6c1999922abd673f89e244208.mp4";